import React from "react";

const NotFound = () => {
  return (
    <div className="conta">
      <h1>404 - Not Found</h1>
      <p>The page you're looking for does not exist.</p>
    </div>
  );
};

export default NotFound;
